const container = "cui-buttongroup-container-qjd5";
const base = "cui-buttongroup-axeq";
const secondary = "cui-buttongroup-secondary-q9rq";
const left = "cui-buttongroup-left-x3yv";
const center = "cui-buttongroup-center-fp91";
const right = "cui-buttongroup-right-pmp3";
const styles = {
  container,
  base,
  secondary,
  left,
  center,
  right
};
export {
  base,
  center,
  container,
  styles as default,
  left,
  right,
  secondary
};
